import { render, staticRenderFns } from "./InappropriateBehaviourEssayActionItem.vue?vue&type=template&id=3f835247&scoped=true&"
import script from "./InappropriateBehaviourEssayActionItem.vue?vue&type=script&lang=js&"
export * from "./InappropriateBehaviourEssayActionItem.vue?vue&type=script&lang=js&"
import style0 from "./InappropriateBehaviourEssayActionItem.vue?vue&type=style&index=0&id=3f835247&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f835247",
  null
  
)

export default component.exports